import { useEffect, useState } from 'react'

export default function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) setVisible(true)
  }, [])

  if (!visible) return null

  const dismiss = (choice: 'accepted' | 'declined') => {
    localStorage.setItem('cookie_consent', choice)
    setVisible(false)
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-[#2c2c2c] px-6 py-4 font-sans text-sm text-[#eee]"
    >
      <div className="mx-auto flex max-w-[960px] flex-wrap items-center justify-between gap-6">
        <p className="m-0 min-w-[240px] flex-1 leading-relaxed">
          We use cookies to improve your experience. By continuing to use Pelvia, you agree to our{' '}
          <a href="/privacy" className="text-[#d4b8a0] underline">
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex flex-shrink-0 gap-3">
          <button
            type="button"
            onClick={() => dismiss('accepted')}
            className="cursor-pointer rounded-md border-0 bg-[#7B5E80] px-5 py-2 text-sm font-medium text-white"
          >
            Accept
          </button>
          <button
            type="button"
            onClick={() => dismiss('declined')}
            className="cursor-pointer rounded-md border border-[#555] bg-transparent px-5 py-2 text-sm text-[#ccc]"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  )
}
